"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const he_1 = require("he");
exports.OsmosysCharacterDecoder = (_a) => {
    var { children } = _a, options = tslib_1.__rest(_a, ["children"]);
    const decodedChildren = react_1.useMemo(() => {
        return he_1.decode(children, options);
    }, [children]);
    return react_1.default.createElement(react_1.default.Fragment, null, decodedChildren);
};
//# sourceMappingURL=OsmosysCharacterDecoder.js.map